export const picturesSelector = state => {
  return state.pictures;
};

export const insidePictureSectionSelector = state => {
  return picturesSelector(state).isInPictureSection;
};

export const uploadingPicturesSelector = state => {
  return picturesSelector(state).uploadingPictures;
};

export const uploadedPicturesSelector =
  (requester = 'default') =>
  state => {
    return picturesSelector(state).preparedToUpload[requester] || [];
  };

export const isPicturesLoadingSelector = state => {
  return !!picturesSelector(state).isLoading;
};

export const isTakingScreenshotSelector = state => {
  return picturesSelector(state).takingScreenshot;
};
